import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Icon from "@shared/components/Icon";
import React from "react";
const CardLabel = ({ image, icon, title, description, alignment = "left", }) => {
    const isCentered = alignment === "center";
    return (_jsxs(Stack, { spacing: 1, sx: {
            alignItems: isCentered ? "center" : "flex-start",
            justifyContent: "flex-end",
            height: "100%",
            p: { xs: 3, md: 4 },
            textAlign: alignment,
            backgroundColor: "background.paper",
            borderColor: "border.default",
            borderWidth: 1,
            borderStyle: "solid",
        }, children: [(image || icon?.icon) && (_jsxs(Stack, { spacing: 1, sx: {
                    alignItems: isCentered ? "center" : "flex-start",
                    pb: { xs: 0.5, md: 1 },
                }, children: [image && !icon?.icon && (_jsx(Box, { sx: {
                            width: "100%",
                            maxHeight: 52,
                            "& img": {
                                height: "52px !important",
                            },
                        }, children: image })), icon?.icon && (_jsx(Icon, { ...icon, style: {
                            fontSize: "48px",
                            minWidth: "52px",
                            minHeight: "48px",
                        } }))] })), title && (_jsx(Typography, { variant: "h6", component: "p", fontWeight: 600, children: title })), description && (_jsx(Typography, { variant: "body2", color: "textSecondary", children: description }))] }));
};
export default CardLabel;
